// Deriva o id_processo enviado na abertura de ticket a partir do vínculo REAL do
// atendimento, nunca do estado de UI de visualização (id_processo_visualizado).
//
// O bug que esta função elimina: a tela permite navegar para "outro processo"
// (processos vinculados / id_processo_visualizado), e o estado idProcesso do
// DetalheProcesso não é ressincronizado. Montar o payload com esse estado fazia a
// abertura enviar um id_processo que não pertence ao atendimento — inclusive o
// processo de outro atendimento do mesmo contato. O desk aceitava e cravava tipo U.
//
// Regra: a fonte da verdade é o processo vinculado ao atendimento ativo
// (atendimentoAtivo.processo). Se o atendimento não tem processo, a abertura vai
// sem processo (null) — e o guard do back bloqueia divergências remanescentes.

/**
 * @param {{processo?: (number|string|null)}} atendimentoAtivo Atendimento em contexto.
 * @returns {(number|string|null)} id_processo a enviar na abertura, ou null.
 */
export function resolverProcessoAbertura(atendimentoAtivo) {
  const processoVinculado = atendimentoAtivo && atendimentoAtivo.processo;
  // ponto único de verdade: o vínculo do atendimento. Falsy (null/undefined/0/'') => sem processo.
  return processoVinculado || null;
}
